import { BRAND } from '../generated/brand';

export const shouldHideForbiddenActions = (): boolean =>
  BRAND.web?.hideForbiddenActions ?? true;

export const shouldRenderForbiddenAction = (
  allowed: boolean,
  hideWhenForbidden = shouldHideForbiddenActions()
): boolean => allowed || !hideWhenForbidden;
